/**
 * If items array contains any banner that item will be returned as it is.
 * Only items with content type "ContentfulAccessory" will go through validation check for active items/ varinats etc...
 */

const getActiveAccessories = (items = []) => {
  const dataToReturn = [];
  items?.forEach((item) => {
    if (item?.__typename !== 'ContentfulAccessory' && !item?.variants) {
      dataToReturn.push(item);
    }

    const activeVariants = getActiveAccessoryVariants(item?.variants);

    if (item?.isActive && activeVariants?.length) {
      const finalData = { ...item, variants: activeVariants };

      dataToReturn.push(finalData);
    }
  });
  return dataToReturn;
};

export const getActiveAccessoryVariants = (variants = []) => variants
  ?.filter(({ price, isActive }) => price > 0 && isActive);

export default getActiveAccessories;
